<template>
  <div class="d-flex sub-nav">
    <assessment-type-select class="mr-1 mr-md-4"></assessment-type-select>

    <property-tenure-select class="mr-1 mr-md-4"></property-tenure-select>

    <due-date-type-select
        v-if="isDashboard"
        class="mr-1 mr-md-4 compliance-type-select py-1 px-3"
    />

    <scrollable-widget
        arrow-bg-color="var(--secondary)"
        arrow-fg-color="var(--gray-dark)"
        :class="['d-none d-sm-flex', {'has-actions': hasActions}]"
        :refresh="hasActions"
    >
        <b-navbar v-if="hasAccess">
            <b-navbar-nav>
                <b-nav-item
                        v-for="item in routes"
                        :key="item.label"
                        :to="item.route"
                        v-if="item.access"
                        :active="isActive(item)"
                >
                    {{ item.label }}
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
    </scrollable-widget>

    <b-navbar v-if="hasAccess" class="d-sm-none flex-grow-1 pr-0" :class="{'pr-3': !hasActions }">
        <b-navbar-nav class="w-100 justify-content-between">
            <div class="d-flex justify-content-between">
                <b-nav-item-dropdown no-caret>
                    <template #button-content>
                        <font-awesome-icon
                            :icon="['far', 'bars']"
                            size="lg"
                            class="text-dark"
                        >
                        </font-awesome-icon>
                    </template>
                    <b-dropdown-item
                            v-for="item in routes"
                            :key="item.label"
                            :to="item.route"
                            :active="isActive(item)"
                    >
                        {{ item.label }}
                    </b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-text class="ml-2 py-1 px-1 text-dark">{{ activeLink }}</b-nav-text>
            </div>
            <b-nav-item
                v-if="!onSingleItemPage"
                href="#"
                @click.prevent="onSearchClick"
                :active="showSearch"
            >
                <font-awesome-icon :icon="['fal', 'search']"></font-awesome-icon>
            </b-nav-item>
        </b-navbar-nav>
    </b-navbar>

    <b-navbar v-if="hasAccess && hasActions" class="py-1 px-3 ml-auto" ref="actionsMenu">
        <portal-target name="properties-subnav"></portal-target>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ScrollableWidget from '@/components/Widgets/ScrollableWidget';
import RoutePermissionsMixin from '@/components/Nav/RoutePermissionsMixin';
import AssessmentTypeSelect from '@/components/Nav/AssessmentTypeSelect';
import PropertyTenureSelect from '@/components/Nav/PropertyTenureSelect';
import DueDateTypeSelect from '@/components/Nav/DueDateTypeSelect';
import { forEach } from 'lodash';
import ActionsMenuVisibilityMixin from '@/components/Nav/ActionsMenuVisibilityMixin';

export default {
  name: 'Property-Navbar',
  mixins: [RoutePermissionsMixin, ActionsMenuVisibilityMixin],
  components: {
    ScrollableWidget,
    AssessmentTypeSelect,
    DueDateTypeSelect,
    PropertyTenureSelect,
  },
  data() {
    return {
      routes: [
        {
          label: 'Management',
          route: { name: 'programme' },
        },
        {
          label: 'Jobs',
          route: { name: 'jobs', children: [{ name: 'job' }] },
        },
        {
          label: 'Hand-Ins',
          route: { name: 'hand-ins' },
        },
        {
          label: 'List',
          route: { name: 'properties', children: [{ name: 'property' }] },
        },
      ],
    };
  },
  computed: {
    ...mapGetters({ showSearch: 'propertyShowSearch' }),
    hasAccess() {
      return true;
    },
    hasActions() {
      return (this.$route.name === 'properties' || this.$route.name === 'programme');
    },
    isDashboard() {
      return this.$route.name === 'property-dashboard';
    },
    onSingleItemPage() {
      return this.$route.params.propertyId
          || this.$route.params.jobRequestId
          || this.$route.params.jobId;
    },
    activeLink() {
      let routeName = this.$route.name;

      if (this.$route.params.fromRoute) {
        routeName = this.$route.params.fromRoute;
      }
      
      if (this.$route.query.tab) {
        routeName = this.$route.query.tab;
      }

      const activeRoute = this.routes.find((item) => {
        if (item.route.name === routeName) {
          return true;
        }

        if (item.route.children) {
          return item.route.children.find(child => child.name === routeName);
        }

        return false;
      });

      return activeRoute ? activeRoute.label : null;
    },
  },
  methods: {
    ...mapActions({ onSearchClick: 'searchPropertyClicked' }),
    isActive(item) {
      const currentRouteName = this.$route.name;
      let isActive = false;
      // Check whether our current route belongs to a child of this.routes
      if (item.route.children) {
        forEach(item.route.children, (value) => {
          if (currentRouteName === value.name) {
            isActive = true;
            return false;
          }

          return true;
        });
      }

      if (currentRouteName === item.route.name) {
        isActive = true;
      }

      const routeQueryIsSet = this.$route.query && this.$route.query.tab;
      const routeQuery = this.$route.query.tab;

      if (routeQueryIsSet && routeQuery === item.route.name) {
        return true;

      }

      if (routeQueryIsSet && routeQuery !== item.route.name) {
        return false;
      }

      let fromRouteName = null;

      if (this.$route.params) {
        // If we have a specific fromRouteName (which we passed in as a
        // parameter) we reset the isActive flag to false
        fromRouteName = this.$route.params.fromRoute;

        if (fromRouteName) {
          isActive = false;

          // If the fromRouteName params matches the current route, then
          // we set the isActive flag back to true
          if (fromRouteName === item.route.name) {
            isActive = true;
          }
        }
      }

      return isActive;
    },
  },
};
</script>
